import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { ProgramStudentStatus } from '../../../../../api/types/programs/students/program-student-status';
import { ProgramStudent } from '../../../../../api/types/programs/program-details';
import { updateProgramStudentStatusOperation } from '../operations/update-program-student-status-operation';
import globalConfigStore from '../../../../../stores/global-config-store';
import globalProgramStore from '../../../../../stores/program-store';

interface ProgramStudentStatusDialogProps {
  visible: boolean;
  onHide: () => void;
  student: ProgramStudent | null;
}

export const ProgramStudentStatusDialog: React.FC<
  ProgramStudentStatusDialogProps
> = ({ visible, onHide, student }) => {
  const [loading, setLoading] = useState(false);
  const [newStatus, setNewStatus] = useState<ProgramStudentStatus | null>(
    student?.status || null,
  );
  const [statusDate, setStatusDate] = useState<Date | null>(new Date());

  if (!student) return null;

  const studentStatusOptions = [
    {
      label: 'נרשם',
      value: ProgramStudentStatus.REGISTERED,
    },
    {
      label: 'לומד',
      value: ProgramStudentStatus.STUDYING,
    },
    {
      label: 'ביטל',
      value: ProgramStudentStatus.CANCELLED,
    },
    {
      label: 'עזב',
      value: ProgramStudentStatus.LEFT,
    },
    {
      label: 'סיים',
      value: ProgramStudentStatus.COMPLETED,
    },
    {
      label: 'דופלם',
      value: ProgramStudentStatus.GRADUATED,
    },
  ];

  const updateStudentStatus = async () => {
    if (!newStatus || !statusDate) return;

    const branchId = globalConfigStore.rootFilter.currentBranches?.id;
    const programId = globalProgramStore.getCurrentId();

    if (!branchId || !programId) return;

    await updateProgramStudentStatusOperation(
      branchId,
      programId,
      student.id,
      newStatus,
      statusDate,
      setLoading,
      onHide,
    );
  };

  return (
    <Dialog
      header={'עדכון סטטוס סטודנט'}
      visible={visible}
      style={{ width: '450px' }}
      modal
      onHide={onHide}
      footer={
        <div>
          <Button
            label="ביטול"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
          />
          <Button
            label="עדכון"
            icon="pi pi-check"
            onClick={updateStudentStatus}
            disabled={!newStatus || !statusDate}
            autoFocus
            loading={loading}
          />
        </div>
      }
    >
      <div className="status-dialog-content">
        <div className="field" style={{ marginBottom: '1rem' }}>
          <label
            htmlFor="status"
            style={{ display: 'block', marginBottom: '0.5rem' }}
          >
            סטטוס
          </label>
          <Dropdown
            id="status"
            value={newStatus}
            options={studentStatusOptions}
            style={{ height: '36px', width: '100%', alignItems: 'center' }}
            onChange={(e) => setNewStatus(e.value)}
            placeholder="בחר סטטוס"
          />
        </div>
        <div className="field">
          <label
            htmlFor="date"
            style={{ display: 'block', marginBottom: '0.5rem' }}
          >
            תאריך
          </label>
          <Calendar
            id="date"
            value={statusDate}
            onChange={(e) => setStatusDate(e.value || null)}
            dateFormat="dd/mm/yy"
            style={{ width: '100%' }}
            placeholder="בחר תאריך"
          />
        </div>
      </div>
    </Dialog>
  );
};
